import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PreDisclaimerGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const accepted = localStorage.getItem('predisclaimerAccepted');
    if (accepted === 'true') {
      return true;
    } else {
      this.router.navigate(['/predisclaimer']);
      return false;
    }
  }
}
